<!--配送车辆证照列表 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
            <vehicleCuringAction v-if="showStatus" ref="vehicleCuringAction" @drawerCancel="drawerCancel" :actionData="actionData"></vehicleCuringAction>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" :flagList="[]" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
                </vSearch>
            </div>
        </div>
        <div class="page_content_center">
            <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
                <el-table-column label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <!-- 主表单 -->
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip :min-width="tableValye.fieldWeight">
                        <template slot="header">
                            <div>
                                <el-tooltip :content="tableValye.showField" placement="top">
                                    <div class="long_title"><span>{{ tableValye.showField }}</span></div>
                                </el-tooltip>
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <span v-if="tableValye.entityField == 'smState'">{{ scope.row.smState == 0 ? '停用' :
                                    '启用' }}</span>
                            <!-- 状态判断 -->
                            <el-tag v-else-if="tableValye.entityField == 'gsmState'" size="mini">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row.gsmState) }}</el-tag>
                            <!-- 成立日期 -->
                            <span v-else-if="tableValye.entityField == 'vlTervalidity'">
                                <span v-if="scope.row[tableValye.entityField]">{{ $common.getLocalTime(scope.row[tableValye.entityField]) }}</span>
                            </span>
                            <!-- 营业期限 -->
                            <span v-else-if="tableValye.entityField == 'vcTime'">
                                <span v-if="scope.row[tableValye.entityField]">{{ $common.getLocalTime(scope.row[tableValye.entityField]) }}</span>
                            </span>
                            <span v-else-if="tableValye.entityField == 'fileId'">
                                <span v-if="scope.row.uploadVoList.length >= 1">
                                    <cusImage v-for="(item, key) in scope.row.uploadVoList" :key="key" :src="imgUrl + '/' + item.fileUrl" style="width: 20px; height: 20px"
                                              :preview-src-list="pictureShow(scope.row.uploadVoList)">
                                    </cusImage>
                                </span>
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                            </span>
                            <span v-else>{{ scope.row[tableValye.entityField] }}</span>

                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>

        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" :parentSearchData="parentSearchData" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"
import vehicleCuringAction from '@/components/vehicleCuringAction.vue'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: { SearchScheme, vehicleCuringAction },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                smName: "",
                smHemcode: "",
                page: 1,
                rows: 30,
                start: "",
                end: "",
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            pageShowData: [], //列表数据
            selectedDataIndex: 0,
            formDataList: [],
            imgUrl: "", //图片显示根路径
            showStatus: false,
            actionData: [],
            DialogVisible: false,
            seId: "",
            seTitle: "",
            seWidth: "",
            sField: "",
            parentSearchData: {},
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 子组件触发
        drawerCancel() {
            this.showStatus = false;
            this.getDataList();
        },
        async toDetail(dh) {
            let responseData = await this.$http.getPenetrateData({
                ids: [dh]
            });
            if (responseData.status == 200) {
                var res = responseData.result;
                this.$refs[res.component].openBox(2, res.dyform, "", res.data);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //图片地址转换
        pictureShow(data) {
            var imgList = [];
            data.forEach((item) => {
                imgList.push(this.imgUrl + "/" + item.fileUrl);
            });
            return imgList;
        },

        isShowData(name, value) {
            this.getRequestData[name] = value;
        },
        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId],
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                this.formDataList = this.pageShowData.jurFormVoList
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
                this.getButtonList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0: //新增
                    this.showStatus = true;
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: "",
                        orderId: "",
                        printSouce: "",
                        printJurId: "",
                        fatherType: "GSP",
                    };
                    break;
                case 1: //修改
                    this.openDataActionBox(actionData.actionType);
                    break;
                case 2: //删除
                    this.delDataAction();
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },

        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.seType = type;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        //提取返回
        changeInputModel(val) {
            console.log(this.seType, val)

            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        openDataActionBox(cate) {
            if (cate == 0) {
                this.showStatus = true;
                this.actionData = {
                    cate: 0,
                    formData: this.formDataList,
                    oldData: "",
                    orderId: "",
                    printSouce: "",
                    printJurId: "",
                    fatherType: "GSP",
                };
            } else {
                if (this.returnData.list.length <= 0) {
                    this.$message({
                        message: "暂无数据",
                        type: "error",
                    });
                    return false;
                }
                if (!this.returnData.list[this.selectedDataIndex]) {
                    this.$message({
                        message: "请先选择您要操作的数据",
                        type: "error",
                    });
                    return false;
                }
                var olddataInfo = this.returnData.list[this.selectedDataIndex];
                let dataInfo = JSON.parse(JSON.stringify(olddataInfo));
                this.showStatus = true;
                this.actionData = {
                    cate: 1,
                    formData: this.formDataList,
                    oldData: dataInfo,
                    orderId: dataInfo.vcId,
                    printSouce: "",
                    printJurId: "",
                    fatherType: "GSP",
                };
            }
        },

        // 获取数据列表
        async getDataList() {
            // console.log(this.getRequestData);
            let responseData = await this.$http.vehicleCuringquery(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
                // console.log(this.returnData);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 删除数据
        delDataAction() {
            if (this.returnData.list.length <= 0) {
                this.$message({
                    message: "暂无数据",
                    type: "error",
                });
                return false;
            }
            if (!this.returnData.list[this.selectedDataIndex]) {
                this.$message({
                    message: "请先选择您要操作的数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            console.log(dataInfo);
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.vcId],
                    };
                    let responseData = await this.$http.vehicleCuringdelete(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                })
                .catch(() => { });
        },
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
//获取状态
        getIsGsp(str, val) {
            try {
                let arr = JSON.parse(str);
                let len = arr.length;
                let newStr = "";
                for (let i = 0; i < len; i++) {
                    if (arr[i].key === val) {
                        newStr = arr[i].value;
                        break;
                    }
                }
                return newStr;
            } catch (ex) {
                return str;
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
        this.imgUrl = this.$store.getters.getConfig.imgUrl;
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>